import { render, staticRenderFns } from "./SpaceAir.vue?vue&type=template&id=44cbb0bb&scoped=true"
import script from "./SpaceAir.vue?vue&type=script&lang=js"
export * from "./SpaceAir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cbb0bb",
  null
  
)

export default component.exports